import Role from 'models/core/role/Model.Role';
import Model from 'models/Model';
import claimJobPaymentEmailTemplateDeleteApi from './delete/Api.ClaimJobPaymentEmailTemplate.Delete';
import claimJobPaymentEmailTemplateListApi from './list/Api.ClaimJobPaymentEmailTemplate.List';
import claimJobPaymentEmailTemplateSaveApi from './save/Api.ClaimJobPaymentEmailTemplate.Save';

export default class ClaimJobPaymentEmailTemplate
  extends Model<Model.IClaimJobPaymentEmailTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimJobPaymentEmailTemplate>
{
  id: number;
  name: string;
  claimJobPaymentStatusTrigger: Model.Enum.ClaimJobPaymentStatusTriggers;
  senderEmail: string;
  senderName: string;
  subject: string;
  htmlBody: string;
  recipientsWithRole?: Role[];

  sendToRemittanceEmail: boolean = false;
  sendToOwner: boolean = false;
  additionalRecipientEmails: string[] = [];

  languageIsoCode?: Locale.Languages;
  readonly baseEntityId: number;

  constructor(
    data: Partial<Model.IClaimJobPaymentEmailTemplate> | Utils.FormData<Model.IClaimJobPaymentEmailTemplate>,
    language?: Locale.Languages
  ) {
    super(
      {
        recipientsWithRole: [Role],
      },
      language
    );
    this.update(data);
    if (!this.additionalRecipientEmails) this.additionalRecipientEmails = [];
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name,
      info: this.senderName,
      subtitle: this.senderEmail,
    };
  }
  static async list(body?: Api.Core.ClaimJobPaymentEmailTemplate.List.IRequest) {
    const { payload, ...rest } = await claimJobPaymentEmailTemplateListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ClaimJobPaymentEmailTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await claimJobPaymentEmailTemplateSaveApi(this);
  }
  async delete() {
    return await claimJobPaymentEmailTemplateDeleteApi(this.id);
  }
}
